import endpoints from 'api/endpoints';
import { normalize } from 'normalizr';
import { board } from 'schemas';
import Immutable from 'immutable';

export default () => ({
  url: endpoints.getBoardsUrl(),
  queryKey: endpoints.getBoardsUrl(),
  transform: response =>
    normalize(response.data, board.schemasArray).entities,
  transformResult: response => ({
    boards: normalize(response.data, board.schemasArray).result,
  }),
  meta: {
    authToken: true,
  },
  force: true,
  options: {
    headers: {
      Accept: 'application/json',
    },
    method: 'GET',
  },
  update: {
    board: (prevEntities = Immutable.Map(), nextEntities) =>
      prevEntities.mergeDeep(nextEntities),
  },
  updateResult: {
    boards: (_, result) => result,
  },
});
